"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLOOR_PLAN_FILTER_BAR_INITIAL_VALUES = exports.ALL_OCCUPANCY_TYPES = exports.SSN_EXCEPTION_OPTIONS = exports.OWNERSHIP_STATUS = exports.DISABILITY_TYPE_OPTIONS = exports.HIGHER_LEARNING_STATUS_OPTIONS = exports.YES_NO_OPTIONS = exports.PET_GENDER = exports.EXPENSE_TYPE_AND_FIELD_MAPPING = exports.EXPENSE_PAYMENT_INTERVAL = exports.INCOME_PAYMENT_INTERVAL = exports.AFFORDABLE_INCOME_PAYMENT_INTERVAL = exports.CONVENTIONAL_INCOME_PAYMENT_INTERVAL = void 0;
var entities_1 = require("@common/entities");
var expenses_fields_1 = require("./block-field-templates/expenses_fields");
exports.CONVENTIONAL_INCOME_PAYMENT_INTERVAL = (_a = {},
    _a[entities_1.ConventionalIncomeInterval.Monthly] = 'Monthly',
    _a[entities_1.ConventionalIncomeInterval.Weekly] = 'Weekly',
    _a[entities_1.ConventionalIncomeInterval.Yearly] = 'Yearly',
    _a);
exports.AFFORDABLE_INCOME_PAYMENT_INTERVAL = (_b = {},
    _b[entities_1.AffordableIncomeInterval.Hourly] = 'Hourly',
    _b[entities_1.AffordableIncomeInterval.Weekly] = 'Weekly',
    _b[entities_1.AffordableIncomeInterval.BiWeekly] = 'Bi-Weekly',
    _b[entities_1.AffordableIncomeInterval.SemiMonthly] = 'Semi Monthly',
    _b[entities_1.AffordableIncomeInterval.Monthly] = 'Monthly',
    _b[entities_1.AffordableIncomeInterval.Annually] = 'Annually',
    _b);
exports.INCOME_PAYMENT_INTERVAL = __assign(__assign({}, exports.CONVENTIONAL_INCOME_PAYMENT_INTERVAL), exports.AFFORDABLE_INCOME_PAYMENT_INTERVAL);
exports.EXPENSE_PAYMENT_INTERVAL = (_c = {},
    _c[entities_1.ExpenseInterval.Hourly] = 'Hourly',
    _c[entities_1.ExpenseInterval.Weekly] = 'Weekly',
    _c[entities_1.ExpenseInterval.Monthly] = 'Monthly',
    _c[entities_1.ExpenseInterval.Yearly] = 'Yearly',
    _c);
exports.EXPENSE_TYPE_AND_FIELD_MAPPING = (_d = {},
    _d[entities_1.ExpenseTypes.ChildCareSchoolOrLookForWork] = expenses_fields_1.CHILD_CARE_SCHOOL_OR_LOOK_FOR_WORK_FIELDS,
    _d[entities_1.ExpenseTypes.ChildCareWork] = expenses_fields_1.CHILD_CARE_WORK_FIELDS,
    _d[entities_1.ExpenseTypes.Disability] = expenses_fields_1.EXPENSES_DISABILITY_FIELDS,
    _d[entities_1.ExpenseTypes.Medical] = expenses_fields_1.MEDICAL_FIELDS,
    _d);
exports.PET_GENDER = [
    { label: 'Male', value: 'male' },
    { label: 'Female', value: 'female' },
];
exports.YES_NO_OPTIONS = [
    { label: 'Yes', value: 'yes' },
    { label: 'No', value: 'no' },
];
exports.HIGHER_LEARNING_STATUS_OPTIONS = [
    {
        label: 'Full Time',
        value: 'full_time',
    },
    {
        label: 'Part Time',
        value: 'part_time',
    },
];
exports.DISABILITY_TYPE_OPTIONS = [
    {
        value: 'disability_mobility',
        label: 'Mobility',
    },
    {
        value: 'disability_hearing',
        label: 'Hearing',
    },
    {
        value: 'disability_visual',
        label: 'Visual',
    },
    {
        value: 'disability_mental',
        label: 'Mental',
    },
];
exports.OWNERSHIP_STATUS = [
    { label: 'Owner', value: 'owner' },
    {
        label: 'Renter',
        value: 'renter',
    },
];
exports.SSN_EXCEPTION_OPTIONS = [
    {
        label: 'Individual who does not contend eligible immigration status.',
        value: 'ssn_exception_description_1',
    },
    {
        label: 'Individuals age 62 or older as of January 31, 2010, whose initial determination of eligibility in either a Multifamily or Public and Indian Housing program was begun prior to January 31, 2010 (a break in assistance does not void the exemption).',
        value: 'ssn_exception_description_2',
    },
    {
        label: 'New household member under the age of 6 where disclosure of SSN is delayed for 90 - 180 days.',
        value: 'ssn_exception_description_3',
    },
    {
        label: 'Foster child or adult whose SSN has not been disclosed by the foster agency and for whom HUD has issues a waiver.',
        value: 'ssn_exception_description_4',
    },
];
exports.ALL_OCCUPANCY_TYPES = new Set([
    entities_1.OccupancyType.Affordable,
    entities_1.OccupancyType.Conventional,
    entities_1.OccupancyType.Student,
]);
exports.FLOOR_PLAN_FILTER_BAR_INITIAL_VALUES = {
    showBedBathFilter: false,
    showDepositsFilter: false,
    showMaxRentFilter: false,
    showMinRentFilter: false,
    showMoveInDateFilter: false,
    showMoveOutDateFilter: false,
    showPetFilter: false,
    showPriceFilter: false,
    showSquareFootageFilter: false,
    showSearchByNameFilter: false,
    showSpaceOptionFilter: false,
};
